import { Grid, Stack } from '@mui/material';

import Dimens from '../../../themes/dimens';
import ScheduledActionExceptionsCard from '../components/cards/scheduledActionExceptionsCard';
import ScheduledActionInformationCard from '../components/cards/scheduledActionInformationCard';
import ScheduledActionsTriggersCard from '../components/cards/scheduledActionsTriggersCard';

interface ScheduledActionDetailsContainerProps {
	scheduledActionId: string;
	organisationId: string;
}

const ScheduledActionDetailsContainer = ({
	scheduledActionId,
	organisationId,
}: ScheduledActionDetailsContainerProps) => {
	return (
		<Grid
			container
			columnSpacing={Dimens.spacing3xl}
			rowSpacing={Dimens.spacingXl}
			direction={'row'}
			sx={{ alignItems: 'stretch' }}
		>
			<Grid size={{ xs: 12, md: 8 }}>
				<Stack spacing={Dimens.spacing3xl}>
					<ScheduledActionInformationCard
						scheduledActionId={scheduledActionId}
						organisationId={organisationId}
					/>
					<ScheduledActionsTriggersCard
						scheduledActionId={scheduledActionId}
						organisationId={organisationId}
					/>
				</Stack>
			</Grid>
			<Grid size={{ xs: 12, md: 4 }}>
				<ScheduledActionExceptionsCard
					scheduledActionId={scheduledActionId}
					organisationId={organisationId}
				/>
			</Grid>
		</Grid>
	);
};

export default ScheduledActionDetailsContainer;
